import React, {useEffect} from 'react';
import Grid from "@mui/material/Grid";
import {Container} from "@mui/material";
import StoricoCard from "./StoricoCard";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import HideAppBar from "../../../widgets/header/HideAppBar";

const AllTicketOperatore = () => {
	const classes = BaseStyle();
	
	useEffect(() => {
		document.body.style = "background: none";
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"I miei tickets"} back={true} backPosition={"/gestione/callcenter"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<StoricoCard showButton={false} firstLevel={false}/>
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(AllTicketOperatore);
